<template>
    <div>
        <div
            v-for="(comment, index) in comments"
            :key="comment.id"
            class="mb-4 subject-results-container"
        >
            <div class="d-flex">
                <UserPicture
                    :commentId="comment.id"
                    :user="comment.user"
                    :score="comment.score"
                    :avatarColor="statusColor"
                    :withoutLine="checkIfItsLastItem(index, comments.length)"
                />
                <div class="comment ml-3 p-2">{{ comment.comment }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import UserPicture from './user-picture'
export default {
    props: {
        comments: {
            type: Array,
            required: true,
        },
        statusColor: {
            type: String,
            required: true,
        },
    },
    components: {
        UserPicture,
    },
    methods: {
        checkIfItsLastItem(index, length) {
            return index == length - 1 ? true : false
        },
    },
}
</script>

<style scoped lang="css">
.comment {
    width: 90%;
    min-height: 50px;
    border: 1px solid #e4e5e6;
    box-sizing: border-box;
    border-radius: 4px;
}
</style>
